import * as React from 'react';
import cn from 'classnames';

import * as style from './styles.css';

export interface IHeaderProps {
  isFixed: boolean;
  reviewsCount: React.ReactElement;
  reviewsButtons: React.ReactElement;
}

export const Header: React.FC<IHeaderProps> = ({ isFixed, reviewsCount, reviewsButtons }) => {
  return (
    <div className={cn(style['wrapper'], isFixed && style['wrapper--fixed'])}>
      <div className={style['container']}>
        <div>{reviewsCount}</div>
        <div>{reviewsButtons}</div>
      </div>
    </div>
  );
};
